export enum SpecificationItemAnswerStatus {
  ALL = -1,
  SEARCHING = 0,
  ANSWERED_PARTIALLY = 1,
  ANSWERED_YES = 2,
  ANSWERED_NO = 3,
  NOT_FOUND = 4,
}

export const SpecificationItemAnswerStatusText = {
  [SpecificationItemAnswerStatus.ALL]: "all",
  [SpecificationItemAnswerStatus.SEARCHING]: "searching",
  [SpecificationItemAnswerStatus.ANSWERED_PARTIALLY]: "partially",
  [SpecificationItemAnswerStatus.ANSWERED_YES]: "yes",
  [SpecificationItemAnswerStatus.ANSWERED_NO]: "no",
  [SpecificationItemAnswerStatus.NOT_FOUND]: "not_found",
}